// extracted by mini-css-extract-plugin
export default {"gearCheck":"VendingDishesGear_gearCheck__nGYDd","gearHeader":"VendingDishesGear_gearHeader__07Zsn","placeHolderShimmer":"VendingDishesGear_placeHolderShimmer__4sdLM"};